import { Link } from 'react-router-dom';

export default function ArticleIntro() {
  return (
    <section className="bg-accent-100/40">
      <div className="max-w-4xl mx-auto px-4 md:px-6 py-20 md:py-28 text-center">
        <p className="text-accent-700 text-xs md:text-sm uppercase tracking-[0.2em] font-semibold mb-4">
          &mdash; Latest Insights &mdash;
        </p>

        <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-500 text-white text-xs font-semibold mb-6">
          <i className="ri-star-fill text-sm"></i>
          <span>5.0</span>
        </div>

        <blockquote className="text-lg md:text-2xl font-heading font-medium text-foreground-950 leading-relaxed max-w-3xl mx-auto mb-8">
          &ldquo;The <strong>Vigorbuy Spreadsheet</strong> has transformed how I discover and compare products. Instead of spending hours browsing multiple sites, I now find everything I need in one organized database. Whether you are looking for the latest sneakers, trending hoodies, or everyday accessories, this resource center makes smart shopping effortless and enjoyable.&rdquo;
        </blockquote>

        <div className="flex items-center justify-center gap-3 mb-8">
          <div className="w-10 h-10 rounded-full overflow-hidden bg-accent-200 flex items-center justify-center">
            <img
              src="https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20woman%20in%20her%20thirties%20with%20warm%20confident%20smile%20wearing%20cream%20blouse%20against%20soft%20beige%20studio%20backdrop%20natural%20window%20light%20editorial%20quality%20clean%20minimal%20composition&width=80&height=80&seq=author-v2-portrait-f5k9m&orientation=squarish"
              alt="Author"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="text-left">
            <p className="text-sm font-semibold text-foreground-950">Sarah Mitchell</p>
            <p className="text-xs text-foreground-500">Editor &amp; Product Reviewer</p>
          </div>
        </div>

        <Link
          to="/articles/vigorbuy-spreadsheet-guide"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-foreground-950 text-white text-sm font-semibold whitespace-nowrap cursor-pointer hover:bg-foreground-800 transition-colors"
        >
          Read the Full Guide
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}